export default "__VITE_ASSET__BDqPjIQi__"